import React, { useEffect, useState } from 'react';
import { apis, models } from "@vote4dance/judging-sdk";
import { HeaderContainer, BodyContainer } from "../../../../base-react/components/Container";
import { Typography, notification, Form, Select, Button } from 'antd';
import { useParams } from "react-router-dom";
import { _T } from "../../../../base-react/src/Localization";
var Api = apis.Api;
import { useCompetition } from '../../../../base-react/hooks/Competition';
var CompetitionSource = models.competitions.CompetitionsSource;
import { Loading } from '../../../../base-react/components/Loading';
const { Title, Text } = Typography;
export const LiveResults = () => {
    let { competition_id } = useParams();
    const [inputCompetition, event, competitions, loadingCompetition, , canEdit] = useCompetition(competition_id);
    const [loading, setLoading] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);
    const [form] = Form.useForm();
    useEffect(() => {
        if (inputCompetition) {
            form.resetFields();
            form.setFieldsValue({
                ...inputCompetition,
                competition_schedule_times_visibility: event ? event.competition_schedule_times_visibility : inputCompetition.competition_schedule_times_visibility
            });
            setHasChanges(false);
        }
    }, [inputCompetition]);
    const onFinish = async (values) => {
        setLoading(true);
        const updateItem = {
            ...inputCompetition,
            ...values
        };
        if ((inputCompetition === null || inputCompetition === void 0 ? void 0 : inputCompetition.competition_parent_id) != null && parseInt(inputCompetition.competition_parent_id) > 0) {
            if (event && event.competition_schedule_times_visibility != values['competition_schedule_times_visibility']) {
                await Api.update(`${CompetitionSource.url}/${event.competition_id}`, {
                    ...event,
                    competition_schedule_times_visibility: values['competition_schedule_times_visibility']
                });
            }
        }
        await Api.update(`${CompetitionSource.url}/${inputCompetition.competition_id}`, updateItem)
            .catch((err) => {
            notification.error({
                message: err.message
            });
        });
        setLoading(false);
        setHasChanges(false);
    };
    const onValuesChange = () => {
        setHasChanges(true);
    };
    if (loadingCompetition) {
        return React.createElement(Loading, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, null, _T('live.title')),
                React.createElement(Text, { type: "secondary" }, _T('live.extra')))),
        React.createElement(BodyContainer, null,
            React.createElement(Form, { name: "customer_live_form", form: form, labelCol: { span: 4 }, wrapperCol: { span: 6 }, onValuesChange: onValuesChange, onFinish: onFinish, disabled: !canEdit, labelWrap: true },
                React.createElement(Form.Item, { name: "competition_publish_liveplacement", label: _T('competition.details.competition_publish_liveplacement.label') },
                    React.createElement(Select, null,
                        React.createElement(Select.Option, { value: 0, key: 0 }, _T('competition.details.competition_publish_liveplacement.level.0')),
                        React.createElement(Select.Option, { value: 2, key: 2 }, _T('competition.details.competition_publish_liveplacement.level.2')),
                        React.createElement(Select.Option, { value: 1, key: 1 }, _T('competition.details.competition_publish_liveplacement.level.1')))),
                React.createElement(Form.Item, { name: "competition_publish_results", label: _T('competition.details.competition_publish_results.label') },
                    React.createElement(Select, null,
                        React.createElement(Select.Option, { value: 0, key: 0 }, _T('competition.details.competition_publish_results.level.0')),
                        React.createElement(Select.Option, { value: 1, key: 1 }, _T('competition.details.competition_publish_results.level.1')),
                        React.createElement(Select.Option, { value: 2, key: 2 }, _T('competition.details.competition_publish_results.level.2')))),
                React.createElement(Form.Item, { name: "competition_schedule_times_visibility", label: _T('competition.details.competition_schedule_times_visibility.label') },
                    React.createElement(Select, null,
                        React.createElement(Select.Option, { value: 0, key: 0 }, _T('common.enable')),
                        React.createElement(Select.Option, { value: 1, key: 1 }, _T('common.disabled')))),
                React.createElement(Form.Item, { wrapperCol: { offset: 8, span: 16 } },
                    React.createElement(Button, { type: "primary", htmlType: "submit", loading: loading, disabled: !hasChanges || !canEdit }, _T('common.save')))))));
};
